module.exports = __webpack_public_path__ + "static/media/h2.43156f79.png";